import { styled } from '@linaria/react'
import React from 'react'
import { Helmet } from 'react-helmet'

import type { CasinoCategory } from '../../store/types/casino'
import type { Theme } from '../../types/common'
import classNames from '../../utils/classNames'

interface GameCategoryIconProps extends CasinoCategory {
  isActive: boolean
  theme?: Theme
  size?: number
  className?: string
}

const IconContainer = styled.div`
  .active {
    display: none;
  }
  .default {
    display: block;
  }
  &.active {
    .active {
      display: block;
    }
    .default {
      display: none;
    }
  }
  @media (min-width: 1200px) {
    &.active,
    &:hover {
      .active {
        display: block;
      }
      .default {
        display: none;
      }
    }
  }
`

const CategoryIcon = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
`

const GameCategoryIcon = (props: GameCategoryIconProps) => {
  const {
    size = 40,
    isActive = false,
    theme = 'light',
    icon_active,
    icon_light_off,
    icon_dark_off,
    className = '',
  } = props

  return (
    <IconContainer
      className={classNames(isActive && 'active', className)}
      style={{
        width: size,
      }}>
      <Helmet>
        <link rel="preload" as="image" href={icon_active} />
        <link rel="preload" as="image" href={icon_dark_off} />
        <link rel="preload" as="image" href={icon_light_off} />
      </Helmet>
      <CategoryIcon src={icon_active} className="active" />
      <CategoryIcon
        src={theme === 'light' ? icon_light_off : icon_dark_off}
        className="default"
      />
    </IconContainer>
  )
}

export default GameCategoryIcon
